module.exports = __webpack_public_path__ + "img/u128.0273049e.svg";